import React from "react";
import PageLayout from "../components/helpers/PageLayout";
import Details from "../components/details/details";

const Home = () => (
    <PageLayout title="RS4SD | Home">
        <Details />
    </PageLayout>
);

export default Home;
